import cx from 'classnames'
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import ButtonCardWrapper, { RadioButtonContent, useIsSelected } from './ButtonCardWrapper'
import { ButtonCardProps, CheckboxButtonContentProps } from './buttonCardProps'
import './styles.scss'

const checkboxBtnPrefixCls = 'checkbox-btn-card'

function CheckboxButtonContent({ isSelected, ...rest }: CheckboxButtonContentProps) {
  return (
    <div className={`${checkboxBtnPrefixCls}-wrapper`}>
      {isSelected ? <FontAwesomeIcon icon={faCheck} className={cx(`${checkboxBtnPrefixCls}-icon`)} /> : null}
      <RadioButtonContent {...rest} />
    </div>
  )
}

/**
 * Use this component to allow the user select/unselect an Item normally presented
 * in a list of choices. You can use it with SelectableCardGrid component to
 * build a list of options .
 *
 * This component is presented in a Card styling
 *
 * @param props - {@link ButtonCardProps}
 */
const CheckboxButtonCard = React.forwardRef<HTMLDivElement, ButtonCardProps & CheckboxButtonContentProps>(
  ({ isSelected, disabled, initialSelected, onClick, className, ...buttonContentProps }, ref) => {
    const [selected, toggleSelected] = useIsSelected({ initialSelected, controlledSelected: isSelected })

    const handleOnClick: ButtonCardProps['onClick'] = (e) => {
      toggleSelected()
      if (onClick) {
        onClick(e)
      }
    }

    return (
      <ButtonCardWrapper
        ref={ref}
        isSelected={selected}
        disabled={disabled}
        onClick={handleOnClick}
        className={className}
        role="checkbox"
      >
        <CheckboxButtonContent isSelected={selected} {...buttonContentProps} />
      </ButtonCardWrapper>
    )
  }
)
CheckboxButtonCard.displayName = 'CheckboxButtonCard'

export default CheckboxButtonCard
